import script from "./TxnStatusBanner.vue?vue&type=script&setup=true&lang=js"
export * from "./TxnStatusBanner.vue?vue&type=script&setup=true&lang=js"

import "./TxnStatusBanner.vue?vue&type=style&index=0&id=e42f8686&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e42f8686"]])

export default __exports__